import { useEffect } from 'react'

const DocumentTitle = (props: any) => {
    useEffect(() => {
        document.title = `${props} | Livetecs`;
    }, [props]);
}
export default DocumentTitle